module.exports = __webpack_public_path__ + "img/prima.42be8488.png";